<mat-card class="filter">

  <span>All Organizations ({{totalCount}})</span>
  
  <mat-form-field appearance="" class="sortBy">
    <mat-label>Sort By</mat-label>
    <mat-select>
      <mat-option value="All">All</mat-option>
      <mat-option value="active">Active</mat-option>
      <mat-option value="inactive">Inactive</mat-option>
    </mat-select>
  </mat-form-field>
  
  <button *ngIf="OrgCreateoption" mat-flat-button color="primary" (click)="addNew('New','')" class="addnew">
    Create Organization
  </button>
</mat-card> 

<mat-card class="table">
  <div class="table-header table-row">
    <div class="col_holder">
      <div class="td icon"></div>
      <div class="td name">Organization Name</div>
      <div class="td">Organization Type</div>
      <div class="td">Database Type</div>
      <div class="td">Database Name</div>
      <div class="td">Representative Person</div>
      <div class="td">Email</div>
      <div class="td">Phone</div>
    </div>
  </div>
  <div class="rowtable table-row" *ngFor="let row of organizationList; let rowIndex = index">
    <div class="table-row">
     <div class="col_holder">
          <div class="td icon">
            <span *ngIf="isRowClickable(rowIndex)">
            <span *ngIf="expanded[row.officeName]"><button (click)="expanded[row.officeName] = !expanded[row.officeName]" mat-icon-button color="basic" ><mat-icon>expand_less</mat-icon></button></span>
            <span *ngIf="!expanded[row.officeName]"><button (click)="expanded[row.officeName] = !expanded[row.officeName]" mat-icon-button color="basic" ><mat-icon>expand_more</mat-icon></button></span>
          </span>
        </div>
        <div class="td name">
          <span class="orgName" *ngIf="officeAdmin==false" (click)="Orgdetails(row)">{{row.officeName}}</span>
          
          <span *ngIf="officeAdmin==true">{{row.officeName}}</span>
           <button *ngIf="Officecreateoption" class="addOrg" mat-icon-button color="primary" (click)="addNew('Existing',row)"><mat-icon>add</mat-icon>
          </button>
          <span class="lbltag" *ngIf="row.isActive==false">Inactive</span>
          <span class="lbltag_active" *ngIf="row.isActive==true">Active</span>
        </div> 
        <div class="td">{{row.domainName}}</div> 
        <div class="td" *ngIf="row.databaseType==1">Shared</div> 
        <div class="td" *ngIf="row.databaseType==2">Dedicated</div> 
        <div class="td" *ngIf="row.databaseType==3">Dedicated Shared</div> 
        <div class="td">{{row.databaseName}}</div> 
        <div class="td">{{row.contactFirstName}} {{row.contactLastName}}</div>
        <div class="td email">
          <span  matTooltipClass="tooltip"  matTooltip="{{row.email}}">{{row.email}}</span>
        </div>    
        <div class="td">{{row.phoneNumber}}</div>   
     </div>      
      <div [@detailExpand]="expanded[row.officeName] ? 'expanded' : 'collapsed'">
      
        <div  class="child-row" *ngFor="let childrow of row.offices">
          <div class="td icon"></div>
          <div class="td name"><mat-icon color="primary" >subdirectory_arrow_right</mat-icon> <span class="orgName" (click)="Orgdetails(childrow)">{{childrow.officeName}}</span>
            <span class="lbltag" *ngIf="childrow.isActive==false">Inactive</span>
            <span class="lbltag_active" *ngIf="childrow.isActive==true">Active</span>
          </div>
          
          <div class="td "><span class="orgName" (click)="Orgdetails(childrow)">{{childrow.domainName}}</span>
          </div>
          <!-- <div class="td">{{childrow.databaseName}}</div> -->
          <div class="td" *ngIf="childrow.databaseType==1">Shared</div> 
          <div class="td" *ngIf="childrow.databaseType==2">Dedicated</div> 
          <div class="td" *ngIf="childrow.databaseType==3">Dedicated Shared</div>
          <div class="td">{{childrow.databaseName}}</div> 
          <div class="td">{{childrow.contactFirstName}} {{childrow.contactLastName}}</div>
          <div class="td email">
            <span  matTooltipClass="tooltip"  matTooltip="{{childrow.email}}">{{childrow.email}}</span>
          </div>    
          <div class="td">{{childrow.phoneNumber}}</div> 
        </div>
    </div>
    </div>
  </div>

  <div *ngIf="organizationListShow">  
    <p style="text-align: center; padding: 20px;">No Record Found</p>  
   </div>  
</mat-card>

<div class="zui-wrapper">
<div class="zui-scroller">  
</div>
</div>



<app-create-organization *ngIf="addListing" (closeAdd)="getClose($event)" (closeAddAfterSave)="getCloseAfterSave($event)" [ngClass]="{'open': addListing}"
[selectiontype] = "selectiontype"  [organizationData] = "organizationData">
</app-create-organization>

